






import Vue, { PropType } from "vue";
import { GetFilteredCountries } from "../App.vue";
import ParkSite from "../../../shared/ParkSite";
import { TextValue } from "../../../shared/TextValue";

export default Vue.extend({
  name: "CountryFilter",
  props: {
    value: String,
    ParkSitesList: {
      type: Array as PropType<ParkSite[]>,
    },
  },
  computed: {
    computedValue: {
      get(): string {
        return this.value;
      },
      set() {
        // do nothing
      },
    },
  },
  methods: {
    handleInput(value: string): void {
      this.$emit("input", value);
    },
    FilterCountries(): TextValue[] {
      return GetFilteredCountries(this.ParkSitesList);
    },
  },
});
